module.exports = __webpack_public_path__ + "media/18.6c930805.mp3";